export default __webpack_public_path__ + "static/TheRussiantownbuiltbyapples-7e02b153a78d5d4edffcf84c46686b9b.jpg";